const getters = {
	tag: (state) => state.tags.tag,
	tagList: (state) => state.tags.tagList,
	tagWel: (state) => state.tags.tagWel,
}
export default getters
